
<div class="table-responsive-sm blocks w-100">
    <table aria-describedby=""  class="table  " style="width: 100%;">
        <thead>
            <tr class="back-white fw-bold">
                <th class="pb-4 border-bottom-0" scope="col"></th>
                <th class="pb-4 border-bottom-0" scope="col">#</th>
                <th class="pb-4 border-bottom-0" scope="col">Data creazione</th>
                <th class="pb-4 border-bottom-0" scope="col">Provincia</th>
                <th class="pb-4 border-bottom-0" scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr class="table-font grabbable" 
                [ngClass]="{'active-row':rowClickActive === true}"
                *ngFor="let obj of entityList; let i = index"
                draggable="true"
                (mousedown)= "rowClickMouseDown($event)"
                (mouseup) = "rowClickMouseUp($event)"
                (dragover)="allowDrop($event,i)"
                (dragstart)="onDragStart(i)"
                (drop)="onDrop($event, i)">
                <td class="row-grabbable grip">
                    <i class="fas fa-grip-vertical"></i>
                </td>
                <td>{{obj.index}}</td>
                <td>{{obj.createdAt}}</td>
                <td>{{obj.province}}</td>
                <td style="text-align-last: end;">
                    <div class="flex">
                        <a title="Modifica" class="pr-5 btn btn-lg" (click)="clickButtonUpdate(obj.id)"><i class="far fa-pencil ora"></i></a>
                        <a title="Cancella" class="btn btn-lg pl-0" (click)="clickButtonDelete(obj.id)"><i class="far fa-trash-alt red"></i></a>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <!-- FloatingBar-->
    <app-floatingbar [toggleParam]="true" [items]="menuItems" (choiceButton)="choiceButtonResponse($event)"></app-floatingbar>

</div>